<template>
    <div class="CShareLinkedIn">
        <CButton class="w-full" icon="linkedin" label-class="sm:hidden" variant="linkedin" @click="linkedinLink">
            LinkedIn
        </CButton>
    </div>
</template>

<script setup lang="ts">
import { useSharing } from '@/composables/sharing/useSharing'

const props = defineProps<{
    url: string
}>()

const { objectToGetParams } = useSharing()

const linkedinLink = () => {
    window.open(
        'https://linkedin.com/shareArticle' +
            objectToGetParams({
                mini: true,
                url: props.url
            }),
        '__blank'
    )
}
</script>
